import DashboardLayout from "@/layouts/DashboardLayout.vue";
import Dashboard from "@/pages/Dashboard.vue";
import Login from "@/pages/Login.vue";
import Clientes from "@/pages/Clientes.vue"
import Arquivos from "@/pages/Arquivos.vue";
import Versoes from "@/pages/Versoes.vue";
import Boletos from "@/pages/Boletos.vue";
import Notificacoes from "@/pages/Notificacoes.vue";
import Logs from "@/pages/LogsEMS.vue"
import VendaRapidaNFCe from '@/pages/VendaRapidaNFCe/VendaRapidaNFCe.vue'
import ComandosValidacaoLog from '@/pages/ComandosValidacaoLog/ComandosValidacaoLog.vue'
import EstatisticasAcesso from '@/pages/EstatisticasAcesso/EstatisticasAcesso.vue'
import AcessoRealtec from '@/pages/AcessoRealtec/AcessoRealtec.vue'

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard
      },
      {
        path: "clientes",
        name: "Clientes",
        component: Clientes
      },
      {
        path: "arquivos",
        name: "Arquivos",
        component: Arquivos
      },
      {
        path: "versoes",
        name: "Versões",
        component: Versoes
      },
      {
        path: "boletos",
        name: "Boletos",
        component: Boletos
      },
      {
        path: "logs",
        name: "Logs",
        component: Logs
      },
      {
        path: 'VendaRapidaNFCe',
        name: "Venda Rapida NFCe",
        component: VendaRapidaNFCe
      },
      {
        path: 'ComandosValidacaoLog',
        name: 'Comandos de Validação',
        component: ComandosValidacaoLog
      },
      {
        path: 'EstatisticasAcesso',
        name: 'Estatísticas de Acesso',
        component: EstatisticasAcesso
      },
      {
        path: 'Notificacoes',
        name: 'Notificações',
        component: Notificacoes
      },
      {
        path: 'AcessosRealtec',
        name: 'Acessos Realtec',
        component: AcessoRealtec
      }
    ]
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  { path: '*', redirect: "/dashboard" }
];

export default routes;
